import { render, staticRenderFns } from "./item-inventory-edit.vue?vue&type=template&id=7c85f02c&scoped=true"
import script from "./item-inventory-edit.vue?vue&type=script&lang=js"
export * from "./item-inventory-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c85f02c",
  null
  
)

export default component.exports